import React, { useState } from "react";
import { Send, X } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/lib/helpers";
import { toast } from "sonner";

export const InviteStatus = ({ owner, onDone }) => {
  const [busy, setBusy] = useState(false);
  if (owner.login_status !== "invited") return null;
  const resend = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try { const { data } = await api.post(`/landlords/${owner.id}/resend-invite`); toast.success(`Invite resent to ${data.email}`); onDone(); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <span data-testid={`invite-status-${owner.id}`} className="mt-1 inline-flex items-center gap-1.5 text-[0.7rem] text-[#8a6d3b]">
      <span className="px-1.5 py-0.5 rounded-full bg-[#C6A87C]/15">Invited – not signed in yet{owner.invited_at ? ` · ${fmtDate(owner.invited_at)}` : ""}</span>
      <button type="button" data-testid={`resend-invite-${owner.id}`} onClick={resend} disabled={busy} className="underline underline-offset-2 hover:text-foreground disabled:opacity-50">
        {busy ? "Sending…" : "Resend"}
      </button>
    </span>
  );
};

export const OwnerBulkBar = ({ ids, onClear, onDone }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/landlords/bulk-portal-invite", { ids });
      const n = data.sent.length + data.resent.length;
      if (n) toast.success(`${data.sent.length} invite(s) sent${data.resent.length ? `, ${data.resent.length} resent` : ""}`);
      data.failed.forEach((f) => toast.error(`${f.name}: ${f.reason}`));
      onDone();
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="owner-bulk-bar" className="flex flex-wrap items-center gap-2 bg-[#18181A] text-white rounded-md px-4 py-2.5 shadow-lg">
      <span data-testid="owner-bulk-count" className="text-sm font-medium mr-2">{ids.length} selected</span>
      <Button size="sm" variant="secondary" className="h-8" data-testid="owner-bulk-invite" disabled={busy} onClick={run}>
        <Send className="h-3.5 w-3.5 mr-1" />{busy ? "Sending…" : "Send portal invites"}
      </Button>
      <span className="text-xs text-white/60">Owners already signed in are skipped; pending invites are resent.</span>
      <button type="button" data-testid="owner-bulk-clear" onClick={onClear} className="ml-auto text-white/70 hover:text-white"><X className="h-4 w-4" /></button>
    </div>
  );
};
